import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=51aa1b09&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=51aa1b09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa1b09",
  null
  
)

export default component.exports